import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { WindowWrapper } from 'src/app/content-list-management/shared/wrappers/window-wrapper';
import { RestService } from './rest-service';
import { CitywireInternalAccountsService } from '@tpapa/citywire-internal-accounts-angular';

@Injectable({
  providedIn: 'root',
})
export class UserRolesService {
  static readonly ENTITY_IDENTIFIER: string = 'userroles';
  private readonly BASE_USER_SETTINGS_ROUTE = `api/${UserRolesService.ENTITY_IDENTIFIER}`;
  private readonly BUILD_HTTP_ROUTE = (...args) =>
    this.restService.BUILD_HTTP_ROUTE(this.BASE_USER_SETTINGS_ROUTE, ...args);

  constructor(
    private restService: RestService,
    private accountsService: CitywireInternalAccountsService,
    private window: WindowWrapper
  ) {}

  getUserRoles$(): Observable<string[]> {
    return this.accountsService.currentUser.pipe(
      take(1),
      switchMap((user) => {
        const roles = this.window.sessionStorage.getItem(
          `${user.username.toLowerCase()}Roles`
        );

        if (roles === null) {
          return this.restService.get$<string[]>(this.BUILD_HTTP_ROUTE()).pipe(
            map((result) => {
              this.window.sessionStorage.setItem(
                `${user.username.toLowerCase()}Roles`,
                JSON.stringify(result)
              );
              return result;
            })
          );
        } else {
          return of(JSON.parse(roles));
        }
      })
    );
  }

  isUserInRole(role: string): Observable<boolean> {
    return this.getUserRoles$().pipe(
      map((result) => {
        var roles = result.map((result) => result.toLowerCase());
        var roleFound = roles.includes(role.toLowerCase());

        return roleFound;
      })
    );
  }
}
